import { AgencyService } from './../common-theme/api/agency.service';
import { Component, Injector, Inject } from '@angular/core';
import { ContactBaseComponent } from './../common-theme/index';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})

export class ContactComponent extends ContactBaseComponent {
  zoom: number = 13;

  constructor(
    injector: Injector,
    agencyService: AgencyService,
    public openModalService: OpenModalService,
    @Inject(DOCUMENT) private document: any,
    @Inject('WINDOW') public window: any
  ) {
    super(injector, agencyService, window);
  }

  openMessageModal(): void {
    this.openModalService.showContactFormModal();
    this.document.body.classList.add('no-scroll');
  }

  public clickedMarker(latitude: number, longitude: number): void {
    if (this.window) {
      this.window.open('https://maps.google.com?daddr='
        + latitude + ','
        + longitude + '&amp;ll=');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts